import deviceApi from '../api/deviceApi';
import { saveSelectedDevice } from './selectedDeviceActions';
import { loadModels } from './modelActions';
import { selectYourXIndexChanged, dropdownIndex } from './selectYourXIndexActions';
import { selectYourXDropdownToggle } from './selectYourXDropdownsActions';

import { LOAD_DEVICES_SUCCESS } from './actionTypes';

export function loadDevices(brandId, finderTypeId) {
    return function (dispatch) {
        return deviceApi.getDevices(brandId, finderTypeId).then(devices => {
            dispatch(selectYourXIndexChanged(dropdownIndex.brand));
            dispatch(selectYourXDropdownToggle(dropdownIndex.device));
            dispatch(loadDevicesSuccess(devices));
        }).catch(error => {
            throw (error);
        });
    };
}
export function deviceSelected(brandId, deviceId, finderTypeId) {
    return function (dispatch) {
        dispatch(saveSelectedDevice(deviceId));
        dispatch(loadModels(brandId, deviceId, finderTypeId));
    };
}
export function devicePrepopulated(brandId, deviceId) {
    return function (dispatch) {
        dispatch(saveSelectedDevice(deviceId));
        dispatch(selectYourXIndexChanged(dropdownIndex.device));
        dispatch(selectYourXDropdownToggle(dropdownIndex.model));
    };
}
export function loadDevicesSuccess(devices) {
    return { type: LOAD_DEVICES_SUCCESS, devices };
}